import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

const Setting = ({ history }) => {
  const { t } = useTranslation();
  return (
    <div className="container d-flex flex-column">
      <div
        onClick={() => history.push("/profile")}
        className="py-4 text-brand border-bottom"
        id="hoverUp"
      >
        {t("Profile")}
      </div>
      <div
        onClick={() => history.push("/changePassword")}
        className="py-4 text-brand border-bottom"
        id="hoverUp"
      >
        {t("Change Password")}
      </div>
      <div
        onClick={() => history.push("/chooseLanguage")}
        className="py-4 text-brand border-bottom"
        id="hoverUp"
      >
        {t("Choose Language")}
      </div>
      <div
        onClick={() => history.push("/logout")}
        className="py-4 text-brand border-bottom"
        id="hoverUp2"
      >
        {t("Log Out")}
      </div>
    </div>
  );
};

export default withRouter(Setting);
